<div class="email-import-issues" *ngIf="hasContent">
	<button type="button" class="summary" [class.has-errors]="errorCount > 0" (click)="expanded = !expanded" [attr.aria-expanded]="expanded">
		<span class="pi" [class.pi-chevron-down]="expanded" [class.pi-chevron-right]="!expanded"></span>
		{{ summary }}
	</button>

	<div class="body" *ngIf="expanded">
		<ul class="issue-list" *ngIf="issues?.length">
			<li *ngFor="let issue of sortedIssues; trackBy: trackIssue" class="issue" [attr.data-severity]="issue.severity">
				<p-tag [severity]="tagSeverity(issue.severity)" [value]="tagLabel(issue.severity)"></p-tag>
				<div class="issue-text">
					<div class="message">{{ issue.message }}</div>
					<div class="detail" *ngIf="issue.detail">{{ issue.detail }}</div>
				</div>
			</li>
		</ul>

		<div class="images" *ngIf="images?.length">
			<button type="button" class="images-toggle" (click)="imagesExpanded = !imagesExpanded" [attr.aria-expanded]="imagesExpanded">
				<span class="pi" [class.pi-chevron-down]="imagesExpanded" [class.pi-chevron-right]="!imagesExpanded"></span>
				Images ({{ images.length }})
			</button>
			<ul class="image-list" *ngIf="imagesExpanded">
				<li *ngFor="let image of images" class="image" [class.failed]="!!image.error">
					<span class="url" [attr.title]="image.original">{{ truncateMiddle(image.original) }}</span>
					<ng-container *ngIf="image.error; else hostedTpl">
						<span class="sep">—</span>
						<span class="error">{{ image.error }}</span>
					</ng-container>
					<ng-template #hostedTpl>
						<ng-container *ngIf="image.hosted">
							<span class="sep">→</span>
							<span class="url" [attr.title]="image.hosted">{{ truncateMiddle(image.hosted) }}</span>
						</ng-container>
					</ng-template>
				</li>
			</ul>
		</div>
	</div>
</div>
